// Constants
import { DATE_SEPARATOR } from './constants/contract.view.utils.constants';

const getFormattedDate = (): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(DATE_SEPARATOR, '0');
  const month = String(today.getMonth() + 1).padStart(DATE_SEPARATOR, '0');
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};

export { getFormattedDate };
